import MainContentComponent from "../Dashboard/MainContent/MainContentComponent/MainContentComponent";

const LoadedComponent = (props) => {
    if (!props?.loaded) return <></>;
    return <MainContentComponent {...props} />
}

export default LoadedComponent;
